import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { FoundationsButton } from '../../GenericComponents/button';
import { createItem, resetState } from '../../Redux/Admin_Tasks/RunSqlQueriesSlice';
import { AppDispatch, RootState } from '../../Redux/store';
import RunSqlQueriesTable from './RunSqlQueriesTable';
import { getBaseUrl } from '../../Utils';
import { useTitleContext } from "../../Hooks/useTitleContext";


export function RunSqlQueries() {

    const { setTitle } = useTitleContext();
    setTitle("Run Sql Queries");

    const [inputSQLQuery, setInputSQLQuery] = useState('');
    const dispatch: AppDispatch = useDispatch();

    const itemStatus = useSelector((state: RootState) => state.runSqlQueries.status);
    const itemError = useSelector((state: RootState) => state.runSqlQueries.error);
    const itemSuccess = useSelector((state: RootState) => state.runSqlQueries.items);
    const message = useSelector((state: RootState) => state.runSqlQueries.message);

    function parseQueries(input: string): string[] {
        const queries = input.split(';').map(query => query.trim()).filter(query => query.length > 0);
        return queries;
      }

    function handleSubmit(e: React.FormEvent): void {
        e.preventDefault(); // Prevents the default form submission behavior
        const queriesList = parseQueries(inputSQLQuery);
        dispatch(createItem(queriesList));
    }
    useEffect(()=>{
        dispatch(resetState());
    },[])
    return (
        <div className="row" id="page_initial_content">
            <div className="mx-auto offset-lg-2 col-lg-10">
                <div className="row">
                    <div className="col-md-6 text-left pb-4">
                        <div className="header">Type your Command : </div>
                    </div>
                <div className="col-md-6"><a  className="float-right" id="link_backto_admin_tasks" href="#AdminTasks">&laquo; Back to Admin Tasks</a></div>
           
                    <div id="status_message" className="col-12"></div>
                    <br />
                    <div className="col-12">
                        <div className="error field-validation-error" style={{ "display": "inline-block" }}>
                            <center>
                                *Please add semicolon(;) at the end of every query.
                            </center>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div id="textbox" className="padding-bottom-medium clear-both">
                                <center>
                                    {<textarea value={inputSQLQuery} onChange={e => setInputSQLQuery(e.target.value)} id="textcommand" className="textcommand col-12" rows={10} cols={153} name="command"></textarea>}
                                </center>
                            </div>
                            <div>
                                <center>
                                    <FoundationsButton
                                        classes='col-md-12'
                                        type="submit"
                                        id="run_command_el" data-has_loader='true' data-show_loader='true' data-not_auto_disable='true'
                                        data-btn_type_className='app-button'
                                        data-additional_classNamees='btn-md btn-block text-center m-b-20'>
                                        Click to Run
                                    </FoundationsButton>
                                </center>
                            </div>
                        </form>
                        <br />
                        {/* FP-10629 */}
                       <div id="result_message">
                            {message && <p>{message}</p>}
                            {itemStatus === 'failed' && <p>{itemError}</p>}
                        </div>
                        <div>
                         {
                                (() => {
                                    const renderedTables: JSX.Element[] = [];
                                    let i = 0;
                                    const keys = Object.keys(itemSuccess);
                                    while (i >= 0 && i < keys.length) {
                                        const key = keys[i];
                                        const data = itemSuccess[Number(key)];
                                        if (itemStatus === 'succeeded' && data && data.length > 0) {
                                            renderedTables.push(<RunSqlQueriesTable key={key} data={data} />);
                                        }
                                        i++;
                                    }
                                    return renderedTables;
                                })()
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

